import type { Epic } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/takeUntil';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/finally';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import searchBoards from '../../services/search-boards/index.tsx';
import {
	LOAD_MORE,
	loadMoreSuccess,
	loadMoreFailure,
	SEARCH_CHANGED,
} from '../../state/actions.tsx';
import {
	getBaseUrl,
	getLocationType,
	getLocationKey,
	getSearchValue,
	getShowMoreStartAt,
	isSearchUsed,
} from '../../state/selectors.tsx';
import type { State } from '../../state/types.tsx';

export const ERROR = 'navigation-apps.scope-switcher-v2.load-more';
export const browserMetricsKey = 'navigation-apps.scope-switcher-v2.browser-metrics.load-more';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const loadMoreEpic: Epic<any, State> = (action$, store) => {
	const stopActions$ = action$.ofType(SEARCH_CHANGED);

	return action$.ofType(LOAD_MORE).mergeMap(() => {
		const state = store.getState();

		const baseUrl = getBaseUrl(state);
		const locationType = getLocationType(state);
		const locationKey = getLocationKey(state);
		const value = isSearchUsed(state) ? getSearchValue(state) : undefined;
		const startAt = getShowMoreStartAt(state);

		if (!locationKey) {
			log.safeErrorWithoutCustomerData(ERROR, 'Location key does not exist');
			return Observable.of(loadMoreFailure());
		}

		return Observable.fromPromise(
			searchBoards(baseUrl, value, locationType, locationKey, false, startAt),
		)
			.mergeMap((inLocation) => Observable.of(loadMoreSuccess(inLocation)))
			.takeUntil(stopActions$)
			.catch((error) => {
				log.safeErrorWithoutCustomerData(ERROR, error.message, error);
				return Observable.of(loadMoreFailure());
			});
	});
};
